import BuildIcon from '@mui/icons-material/Build'
import DashboardIcon from '@mui/icons-material/Dashboard'
import InsightsIcon from '@mui/icons-material/Insights'
import LowPriorityIcon from '@mui/icons-material/LowPriority'
import PhoneIcon from '@mui/icons-material/Phone'
import QueryStatsIcon from '@mui/icons-material/QueryStats'
import SchoolIcon from '@mui/icons-material/School'
import { haveRole } from '@/lib/admin/getIsUserBackOffice'
import { MENU_GROUPS } from '@/lib/routes/menuGroups'
import { CONSTANTS } from '@/types/enum/constants'

export const routeBackOfficeCallCenterAdminCommon = [
  // Call Center - Super Admin
  {
    route: 'callDashboard',
    menuGroup: MENU_GROUPS.CALL_CENTER,
    text: 'Tableau de bord',
    t: 'routes.backoffice.call.dashboard',
    icon: DashboardIcon,
    href: '/backoffice/call/dashboard',
    menuHeader: true,
    position: 398,
  },
  {
    route: 'callProcedures',
    menuGroup: MENU_GROUPS.CALL_CENTER,
    text: 'Base de connaissance',
    icon: PhoneIcon,
    href: '/backoffice/call/procedures',
    menuHeader: true,
    position: 400,
  },
  {
    route: 'callProcedureStats',
    menuGroup: MENU_GROUPS.CALL_CENTER,
    text: 'Stats procédures',
    icon: InsightsIcon,
    href: '/backoffice/call/stats',
    // Fusionnée dans l'onglet Suivi de la Base de connaissance (P-16) : la route reste pour
    // rediriger les favoris, plus d'entrée de menu.
    menuHeader: false,
    position: 402,
  },
  {
    route: 'callScorePriorities',
    menuGroup: MENU_GROUPS.CALL_CENTER,
    text: 'Priorités',
    icon: LowPriorityIcon,
    href: '/backoffice/call/priorities',
    menuHeader: true,
    position: 404,
  },
  {
    // Page « Production » FUSIONNÉE dans « Priorités » (tri « écart le plus ancien »).
    // L'entrée reste déclarée, hors menu, pour la redirection des favoris : sans elle,
    // withAuthent renvoie à l'accueil avant que la page n'ait pu rediriger.
    route: 'callProduction',
    text: 'Production',
    href: '/backoffice/call/production',
    menuHeader: false,
  },
  {
    route: 'callRelationPharmacien',
    menuGroup: MENU_GROUPS.CALL_CENTER,
    text: 'Relation pharmacien',
    icon: QueryStatsIcon,
    href: '/backoffice/call/relation-pharmacien',
    menuHeader: true,
    position: 408,
  },
  {
    route: 'callProcedureNew',
    text: 'Nouveau document',
    href: '/backoffice/call/procedures/new',
    menuHeader: false,
  },
  {
    route: 'callProcedureEdit',
    text: 'Éditer procédure',
    href: '/backoffice/call/procedures/[id]/edit',
    menuHeader: false,
  },
  // NB : « Mes attestations & formations » et l'espace RH sont declares dans
  // routeBackOfficeAllEntityAdminCommon (groupe OUTILS) depuis P-14 — le vivier est
  // TOUS les admins back-office, plus seulement l'equipe call.
  {
    // Traitement des FEEDBACKS + gestion des categories. RETIRE du menu (demande
    // 23/08) : l'ecran reste accessible par le bouton « Outils » de la page
    // procedures (CallProceduresCards) — la route reste declaree pour la navigation
    // et le controle de roles (withAuthSync).
    route: 'callTools',
    text: 'Outils Call Center',
    icon: BuildIcon,
    href: '/backoffice/call',
    menuHeader: false,
  },
]
